export default __webpack_public_path__ + "static/media/CLINICALs.80d0493a.png";